import DocumentMeta from "react-document-meta";
//import servicios from "../../hooks/servicios.json";

const Servicios = () => {

    return (
        <DocumentMeta {
            ...{
                title: 'Servicios',
                description: 'Servicios',
                canonical: 'https://' + window.location.host + '/servicios',
                meta: {
                    charset: 'utf-8',
                    name: {
                        keywords: `servicios, listado`
                    }
                }
            }
        }>
            <div className="page-title-area ptb-100">
                <div className="container">
                    <div className="page-title-content">
                        <h1>Servicios</h1>
                    </div>
                </div>
                <div className="bg-image">
                    <img src={process.env.PUBLIC_URL + "/assets/img/banner/title.jpg"} alt="" />
                </div>
            </div>
            <div className="about-single-area ptb-100">
                <section id="about" className="about-section about-section-single">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6  d-none d-md-block">
                                <div className="image">
                                    <img src={process.env.PUBLIC_URL + "/assets/img/servicios/asesoramiento.jpg"} alt="" className="img1" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="content">
                                    <h2>
                                        <span>Asesoramiento</span>
                                    </h2>
                                    <p>
                                        ARES dispone de canales de comunicación para asesorar en la instalación, puesta en marcha, uso y disposición final de todos los productos que fabrica.
                                    </p>
                                    <p className="contact-item">☏ +54 (11) 4760 6060</p>
                                    <p className="contact-item">📱 +54 (11) 7228 5050</p>
                                    <p className="contact-item">📱 +54 (11) 5507 0780</p>
                                    <p className="contact-item">✉ ventas@ares.com.ar</p>
                                </div>
                            </div>
                            <div className="col-lg-6 d-md-none">
                                <div className="image">
                                    <img src={process.env.PUBLIC_URL + "/assets/img/servicios/asesoramiento.jpg"} alt="" className="img1" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="promo-area">
                    <div className="container">
                        <div className="row">
                            <div>
                                <div className="promo-inner">
                                    <div className="row align-items-center">
                                        <div className="col-lg-6 col-md-12">
                                            <div className="content">
                                                <h2>
                                                    <span>Instalación y puesta en marcha</span>
                                                </h2>
                                                <p>
                                                    Aunque todos los equipos fabricados por ARES están acompañados de documentación digital para que el usuario pueda realizar su instalación y puesta en marcha, ARES dispone de personal para cotizar estos servicios.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12">
                                            <div className="image">
                                                <img src={process.env.PUBLIC_URL + "/assets/img/servicios/instalacion.jpg"} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="promo-inner">
                                    <div className="row align-items-center">
                                        <div className="col-lg-6 col-md-12 d-none d-md-block">
                                            <div className="image">
                                                <img src={process.env.PUBLIC_URL + "/assets/img/servicios/calibracion.jpg"} alt="" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12">
                                            <div className="content">
                                                <h2>
                                                    Calibración
                                                </h2>
                                                <p className="mb-2">
                                                    Tanto las bombas dosificadoras como los sensores necesitan ser calibrados con cierta frecuencia. La información necesaria para esta tarea figura en los Anexos del Manual de Uso.
                                                </p>
                                                <p className="mb-2">
                                                    ARES cuenta con personal capacitado para realizar estas y otras actividades en campo.
                                                </p>
                                                <p>
                                                    El presupuesto por este servicio, que incluye la entrega de los correspondientes certificados, detalla los requisitos para la realización de las tareas.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 d-md-none">
                                            <div className="image">
                                                <img src={process.env.PUBLIC_URL + "/assets/img/servicios/calibracion.jpg"} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="promo-inner">
                                    <div className="row align-items-center">
                                        <div className="col-lg-6 col-md-12">
                                            <div className="content">
                                                <h2>
                                                    Reparaciones
                                                </h2>
                                                <p>
                                                    Los productos fabricados por ARES poseen una garantía contra todo defecto de fabricación, cuya vigencia es específica para cada tipo de producto. Es importante destacar que las bombas dosificadoras y los instrumentos de control que ARES fabrica NO SON PRODUCTOS DESCARTABLES. ARES mantiene en existencia repuestos de todos los productos fabricados.
                                                </p>
                                                <p>
                                                    En el caso que el usuario desee delegar en ARES la tarea de mantenimiento y eventual reparación de los productos adquiridos, ésta se realizará, una vez aprobado el presupuesto correspondiente, con proedimientos que se ajustan a las reglamentaciones vigentes y con especial cuidado del medio ambiente.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12">
                                            <div className="image">
                                                <img src={process.env.PUBLIC_URL + "/assets/img/servicios/reparacion.jpg"} alt="D" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="container">
                    <blockquote className="blockquote">
                        <div className="image">
                            <img src="assets/img/about/about-quote.jpg" alt="Demo Image" />
                        </div>
                        <p>On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire, that they cannot foresee the pain and trouble that are bound to ensue; and equal blame belongs to those who fail in their duty through weakness of will stop.</p>
                        <span>- Royela Dicasa, CEO</span>
                    </blockquote>
                </div> */}
            </div>
        </DocumentMeta>

    );
}

export default Servicios;